import React, { Component } from 'react'
import HTMLComponent from '../shared/HTMLComponent'
import { Container, Row, Col } from 'react-grid-system'


class About extends Component {

	constructor(props) {
    super(props)

    this.state = {jamie: {
        title: 'Jamie Horgan',
        img: 'https://yoga-jams.s3-us-west-2.amazonaws.com/jamieMachuPicchu.jpeg',
        about: "Jamie was born and raised in Manhattan Beach, California.  Both of her parents grew up in the South Bay as well, making her a second generation, California Native.  Her love for Yoga came in the Fall of 2001 when she attended her first Yoga class by the suggestion of her doctor.  Jamie had experienced severe anxiety growing up, but didn't want to take medication.  After attending just one Yoga class she could feel the profound effect it had on her nervous system.<br /><br />In 2006, Jamie received her 200-hour, Yoga Alliance certified teacher training degree through Mukti Yoga School with her mentor, Julie Rader Wellman (Founder).  Following this certification, she began teaching full-time and also continued her Yoga teaching education. Jamie has completed an eclectic array of trainings specializing in the areas of Advanced Asana, Vinyasa Yoga, Yoga Therapy, Meditation, Pranayama, Kriya Yoga, Kids Yoga, Yoga for Athletes, Yoga Therepeutics, Pre/Post Natal, and a Graduate Training.  In addition to these trainings, Jamie has has trained with Maty Ezraty, Chuck Miller and Annie Carpenter, as well as attended numerous workshops, classes and retreats led by some of the top Yoga teachers in the world.  In 2009, Jamie began leading teacher trainings through Mukti Yoga School and has continued to certify aspiring Yoga teachers since. <br /><br />Jamie travels internationally leading workshops, teacher trainings, and retreats.  Because of her own personal experience using Yoga for healing, she is interested in spreading the beautiful gift of Yoga to as many people as possible. Jamie strongly believes that life is about love and service.<br /><br />Jamie skillfully designs her classes using a unique blend of Hatha Yoga poses that build a purposeful sequence. Her music selection helps transcend you into your practice so that it becomes a moving meditation.  She builds the sequence with the music; just like a soundtrack to a movie.  Having practiced and taught Vinyasa Yoga for several years, and having completed an eclectic array of Yoga teacher trainings, she creates an environment where movement becomes liberation. Jamie strongly believes that every pose should have a purpose and will ultimately lead to a deeper understanding of the body.  Jamie also believes in allowing the student to be their own teacher, listen to their own body, and be guided by their breath.  She opens the body in a way that not only frees your mind, but is also fun, feels good, and is safe on the joints."
        }
    };

    this.jamieImage = (
        <img className="image-rounded" alt="Jamie Horgan" width="100%" src={this.state.jamie.img} />
    )
  }


  render() {
    return (
    		<Container>
        <h1>About</h1>

        <div className="Enter-screen">

          <Row>
            <Col xs={12}>
              <Col sm={6} md={3} className="image">
                {this.jamieImage}
              </Col>

              <h3>{this.state.jamie.title}</h3>

              { HTMLComponent.renderHTML(this.state.jamie.about) }
            </Col>
  				</Row>
        </div>
        </Container>
    )
  }
}


export default About;
